import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { loadTranslations } from '@/utils/translate/translate-server'
import {
  ExpressCheckoutPage,
  ExpressCheckoutPageProps,
  getExpressCheckoutPageProps,
} from '@/views/ExpressCheckoutView/pageProps.server'

export const getServerSideProps = getServerSidePropsErrorHandler<ExpressCheckoutPageProps>(
  async ({ federationClient, locale, next404, params, query, req, res, region }) => {
    const translations = await loadTranslations(locale, ['common', 'pif', 'account', 'app-promo'])
    return getExpressCheckoutPageProps({
      params,
      locale,
      federationClient,
      next404,
      translations,
      req,
      res,
      query,
      region,
      isServerSideRendered: true,
    })
  },
)

export default ExpressCheckoutPage
